module.exports = __webpack_public_path__ + "static/img/kanban09.eb9cfa46.png";